// ── reportSaveError ──────────────────────────────────────────────────────────
// Surface a previously-silent write failure as a user-visible toast. supabase-js
// RESOLVES (does not reject) on a failed write, returning { error } — so any caller
// that ignores that field shows a false "it worked" while nothing persisted. Pass
// the error here: it logs for devs and fires the global `nextep:save-failed` event
// that SaveErrorToast turns into a toast. Returns true when there WAS an error, so
// callers can guard: `if (reportSaveError(error, 'follow')) return  // skip optimistic UI`.
// (Audit 2026-07-06 — extracted from useWatchlist so every write path can share it.)
export function reportSaveError(error, action) {
  if (!error) return false
  console.error(`[save] ${action} failed:`, error.message || error)
  window.dispatchEvent(new CustomEvent('nextep:save-failed', { detail: { action } }))
  return true
}
